import React from 'react';
import {Store} from '../../models/store.model';
import {FormModal} from '../../../../Presentation/components/common';
import {useEditStoreForm} from '../../hooks/useEditStoreForm';
import {StoreFormFields} from '../forms/StoreFormFields';
import {LocationSection} from '../forms/LocationSection';

interface EditStoreModalProps {
  store: Store | null;
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: (updatedStore: Store) => void;
}

export const EditStoreModal: React.FC<EditStoreModalProps> = ({
  store,
  isOpen,
  onClose,
  onSuccess
}) => {
  const {
    formData,
    submitting,
    showMap,
    selectedLocation,
    removedImages,
    handleInputChange,
    handleDeveloperChange,
    handleFileChange,
    handleRemoveExistingImage,
    handleLocationSelect,
    handleSubmit,
    handleCancel,
    toggleMap
  } = useEditStoreForm({store, onSuccess, onClose});

  return (
    <FormModal
      open={isOpen}
      onClose={handleCancel}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      title="تعديل بيانات المتجر"
      width="max-w-4xl"
      submitLabel={submitting ? 'جاري الحفظ...' : 'حفظ التغييرات'}
      cancelLabel="إلغاء"
      isLoading={submitting}
      disabled={submitting}
    >
      <div className="space-y-6">
        {/* Basic Information */}
        <StoreFormFields
          formData={formData}
          onInputChange={handleInputChange}
          onDeveloperChange={handleDeveloperChange}
          onFileChange={handleFileChange}
          onRemoveExistingImage={handleRemoveExistingImage}
          removedImages={removedImages}
        />

        {/* Location Section */}
        <LocationSection
          showMap={showMap}
          selectedLocation={selectedLocation}
          onLocationSelect={handleLocationSelect}
          onToggleMap={toggleMap}
        />
      </div>
    </FormModal>
  );
};
